/* eslint-disable react/prop-types, no-unused-vars */

import { Form, Select } from 'antd';

const TrimCleanTextForm = ({ config, columns, onChange }) => (
    <Form layout="vertical" initialValues={config} onValuesChange={(_, values) => onChange(values)}>
        <Form.Item label="Column" name="column" rules={[{ required: true }]}>
            <Select placeholder="Select column" options={columns.map(c => ({ label: c, value: c }))} />
        </Form.Item>
    </Form>
);

export default TrimCleanTextForm;
